import React, { PureComponent } from 'react';
import ReactTable, { ReactTableDefaults } from 'react-table';
import 'react-table/react-table.css';
import styled from 'styled-components';

import SlotData from './slot-data';

Object.assign(ReactTableDefaults, {
  column: {
    ...ReactTableDefaults.column,
    minWidth: 120,
  },
});

const TableWrapper = styled.div`
  width: 96%;
`;

const Cell = styled.div`
  cursor: ${({ cursor }) => cursor || null};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default class AvailableSlotsView extends PureComponent {
  renderColumns = (col, colIndex) => {
    const { batchView, teacher } = this.props;

    return {
      ...col,
      Cell: cell => {
        const cellData = cell && cell.value;

        if (!cellData) return null;

        return (
          <BatchCell
            key={cellData.key}
            slots={cellData.value}
            batchView={batchView}
            teacher={teacher}
          />
        );
      },
      style: { padding: 0 },
    };
  };

  render() {
    const { tableState, all_timings } = this.props;
    const { data, columns } = tableState || {};

    return (
      <TableWrapper>
        <ReactTable
          data={data}
          columns={columns.map(this.renderColumns)}
          className="-striped -highlight"
          style={{ height: 480 }}
          defaultPageSize={all_timings || 0}
        />
      </TableWrapper>
    );
  }
}

class BatchCell extends PureComponent {
  render() {
    const { slots = [], batchView, teacher } = this.props;

    const availableSlots = slots.filter(slot => slot.isVisible === true);

    return (
      <React.Fragment>
        {availableSlots.map(slot => {
          return <CellSlot {...slot} batchView={batchView} teacher={teacher} />;
        })}
      </React.Fragment>
    );
  }
}

class CellSlot extends PureComponent {
  render = () => {
    const { value, isSelected, isSelectable, batchView, teacher } = this.props;

    return (
      <Cell
        cursor={isSelectable ? 'pointer' : null}
        isSelected={isSelected}
        isSelectable={isSelectable}
        data={value}
      >
        <SlotData data={value} batchView={batchView} teacher={teacher} />
      </Cell>
    );
  };
}
